/**
 * Created by iamso on 27.08.2021
 */

const BattlePassPoints = function (unit, options) { 
    UnitComponent.call(this, unit);

    this.load(options || {});
};

BattlePassPoints.prototype = Object.create(UnitComponent.prototype);
BattlePassPoints.prototype.constructor = BattlePassPoints;

BattlePassPoints.prototype.collect = function () {
    if (this.unit.findComponent(Pulsing)) {
        this.unit.findComponent(Pulsing).setRemoved(true);
    }

    if (Map2d.currentMap.advice) {
        Map2d.currentMap.advice.boo();
    }

    const mission = cleverapps.missionManager.findLocalPass();
    if (!mission || !mission.isRunning()) {
        this.unit.onDestruction();
        this.unit.remove(true);
        return;
    }

    const reward = new Reward("mission", { amount: this.pointsValue, missionType: mission.type });
    reward.receiveReward();

    const source = this.unit.onGetView();
    if (!source) {
        this.unit.onDestruction();
        this.unit.remove(true);
        return;
    }

    this.unit.remove(true);

    reward.collectRewardsAnimation(source, {
        path: true,
        adjustToTarget: true,
        flyingAnimation: Reward.COLLECT_ANIMATION
    });
};

BattlePassPoints.prototype.handleClick = function () {
    this.collect();
    return true;
};

BattlePassPoints.prototype.load = function (stored) {
    if (stored.pointsValue) {
        this.pointsValue = stored.pointsValue;
    } else {
        const pointsData = this.unit.getData().pointsReward;
        this.pointsValue = PseudoRandom.GET().random(pointsData.min, pointsData.max);
    }
};

BattlePassPoints.prototype.save = function (data) {
    data.pointsValue = this.pointsValue;
};